export function arrayBufferToHexString(buffer: ArrayBuffer): string {
	const byteArray = new Uint8Array(buffer);
	let hexString = '';

	for (const byte of byteArray) {
		// Convert each byte to its hexadecimal representation.
		const hex = byte.toString(16).padStart(2, '0');
		hexString += hex;
	}

	return hexString;
}
